var React = require('react');

function CrossInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"strokeWidth":"1.5","fill":"none","fillRule":"evenodd","strokeLinecap":"round","strokeLinejoin":"round"},React.createElement("path",{"d":"M1.282 8.795a7.375 7.375 0 1014.75 0 7.375 7.375 0 00-14.75 0h0zM5.45 5.588l6.414 6.414M11.864 5.588L5.45 12.002"})));
}

CrossInline.defaultProps = {"width":"17","height":"17"};

module.exports = CrossInline;

CrossInline.default = CrossInline;
